import { render } from "./ReferralInformation.vue?vue&type=template&id=35bf4cd8"
import script from "./ReferralInformation.ts?vue&type=script&lang=js&external"
export * from "./ReferralInformation.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__